import React from 'react'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import { useCollection } from '@morningtrain/react-resources'

function SummedCollectionValue ({ name }) {
  const collection = useCollection()
  const plainCollection = toJS(collection)

  const sumKey = (key) => {
    return plainCollection.reduce((a, b) => a + (b[key] || 0), 0)
  }

  return sumKey(name)
}

export default observer(SummedCollectionValue)
